import React from 'react';
import { FontProvider } from '../../fonts/FontProvider';
import { ScopeStyles } from '../../config/ScopeStyles';
import MainSizer from '../../core/common/MainSizer';
import PropTypes from 'prop-types';
import MainSizerWithBanner from './MainSizerWithBanner';
import StudentBrandedDocumentTitle from '../../config/StudentBrandedDocumentTitle';
import TeacherBrandedDocumentTitle from '../../config/TeacherBrandedDocumentTitle';

export default class BasePage extends React.Component {
  static propTypes = {
    titleId: PropTypes.string,
    title: PropTypes.string,
    styleKey: PropTypes.string,
    fontKey: PropTypes.string.isRequired,
    minWidth: PropTypes.string,
    minHeight: PropTypes.string,
    overflow: PropTypes.string,
    overflowX: PropTypes.string,
    overflowY: PropTypes.string,
    children: PropTypes.any.isRequired,
    useBanner: PropTypes.bool,
    teacherBrand: PropTypes.bool,
  };

  render() {
    const Sizer = this.props.useBanner ? MainSizerWithBanner : MainSizer;

    const innerContent = (
      <ScopeStyles styleKey={this.props.styleKey}>
        <FontProvider fontKey={this.props.fontKey}>
          <Sizer
            minWidth={this.props.minWidth}
            minHeight={this.props.minHeight}
            overflow={this.props.overflow}
            overflowX={this.props.overflowX}
            overflowY={this.props.overflowY}
          >
            {this.props.children}
          </Sizer>
        </FontProvider>
      </ScopeStyles>
    );

    const Title = this.props.teacherBrand
      ? TeacherBrandedDocumentTitle
      : StudentBrandedDocumentTitle;

    if (this.props.titleId || this.props.title) {
      return (
        <Title titleId={this.props.titleId} title={this.props.title}>
          {innerContent}
        </Title>
      );
    }

    return innerContent;
  }
}
